import Icon from '../components/Icon.vue'

Icon.register({"gg":{"width":2048,"height":1792,"paths":[{"d":"M736 800l384 384-384 384-672-672 672-672 168 168-96 96-72-72-480 480 480 480 193-193-289-287zM1312 224l672 672-672 672-168-168 96-96 72 72 480-480-480-480-193 193 289 287-96 96-384-384z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/gg.js